module.exports = __webpack_public_path__ + "e9cd589a0ca13c9d5c3c33e857f31f42.png";